<template>
  <breeze-nav-link
    :href="route(pagePath)"
    :active="isActive(pagePath)"
    @click="$root.showMapOnMobile = false"
    class="pr-4 pl-2"
  >
    <div
      class="flex w-full p-1 items-center before:bg-white before:w-1 before:h-8 before:rounded before:mr-2 before:z-10"
      :class="!isActive(pagePath) ? ' before:invisible' : 'text-bold'"
    >
      <slot></slot>
      <span class="ml-2 block" v-show="$root.showMenu">
        {{ title }}
      </span>
    </div>
  </breeze-nav-link>
</template>
<script setup>
import BreezeNavLink from "@/Components/NavLink";
import { defineProps, ref } from "vue";
const props = defineProps({
  path: String,
  title: String,
});

const pagePath = ref(props.path);

function isActive(routeName) {
  return route().current(routeName);
}
</script>
